import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import IngredientButton from '../IngredientButton'
import { Ingredient } from '../../../../types/types'
import { selectIngredient, useAppDispatch } from 'src/store'
import { orderBy } from 'lodash'

export type CategoryIngredientListProps = {
    collapsed: boolean;
    ingredients: Ingredient[];
    selectedIngredients: Ingredient[];
    setCollapsed: (collapsed: boolean) => void
}

const CategoryIngredientList = (props: CategoryIngredientListProps) => {
    let { collapsed, ingredients, selectedIngredients } = props
    const dispatch = useAppDispatch()

    let selectedIngredientIds = selectedIngredients?.map(x => x.id)

    const handleSelect = (ingredient: Ingredient) => {
        dispatch(selectIngredient(ingredient))
    }

    let sortedIngredients = sortIngredients(ingredients)

    return (
        <Box className="ingredient-list-container">
            {(!ingredients || ingredients.length === 0) &&
                <Box sx={{ textAlign: 'center' }}>
                    <CircularProgress sx={{ color: 'white' }} />
                </Box>
            }
            <Box
                className="ingredient-list"
                data-collapsed={collapsed}
            >
                {!collapsed &&
                    sortedIngredients?.map((ing: Ingredient) => {
                        return (
                            <IngredientButton
                                key={ing.id}
                                ingredient={ing}
                                onSelect={handleSelect}
                                selected={selectedIngredientIds?.find(id => id === ing.id) !== undefined}
                            />
                        )
                    })
                }
            </Box>
        </Box>

    )
}

const sortIngredients = (ingredients: Ingredient[]) => {
    return orderBy(ingredients, [
        function (item) { return item.available },
        function (item) { return item.name }
    ], ["desc", "asc"]);
}
const sortIngredientsByNumber = (ingredients: Ingredient[]) => {
    return orderBy(ingredients, x => x.number)
}

export default CategoryIngredientList
